import { configureViemChain } from './chain.js';
import { axios } from './axios.js';
export const fetchChainConfigs = async (baseApiUrl) => {
    const response = await axios.get(`${baseApiUrl}/chains`);
    if (response.data && response.data.chains) {
        return response.data.chains.map((chain) => configureViemChain(chain));
    }
    throw 'No Chain Data';
};
//# sourceMappingURL=fetchChainConfigs.js.map